import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import styles from './DeleteInvoiceDialog.styles.scss';
import cn from 'classnames';

const DeleteInvoiceDialog = ({
  loading,
  deleteRow,
  setDeleteRow,
  confirmDelete,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      onHide={() => setDeleteRow(false)}
      className={cn('rounded-4 overflow-hidden', styles.deleteInvoiceDialog)}
      visible={!!deleteRow}
      footer={
        <>
          <Divider className="mb-4" />
          <div className="d-flex flex-row gap-4">
            <Button
              className="flex-grow-1"
              type="button"
              size="medium"
              label={t('common.cancel')}
              onClick={() => setDeleteRow(false)}
              outlined
            />{' '}
            <Button
              className="flex-grow-1"
              type="button"
              size="medium"
              label={t('common.confirm')}
              disabled={loading}
              loading={loading}
              onClick={() => {
                confirmDelete(deleteRow).then(() => {
                  setDeleteRow(false);
                });
              }}
            />
          </div>
        </>
      }
    >
      <div className={styles.submissionMessage}>
        <span>
          <i className="pi pi-trash" />
        </span>
        <h3>{t('invoice_list.delete_dialog_desc')}</h3>
      </div>
    </Dialog>
  );
};

export default DeleteInvoiceDialog;
